import {NewPersonalDataRoleComponent} from "Core/Controls/FieldSecurity/Components/DataRole/NewDataRole/NewPersonalDataRoleComponent";
import {DataRoles} from "Core/Controls/FieldSecurity/Shared/Enums/DataRoles";

export class NewSORoleComponent extends NewPersonalDataRoleComponent {
	constructor() {
		super(DataRoles.Instance.SO);
	}
}